export const WEB_UPLOAD_CONCURRENCY = 16;
